import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import LinkButton from 'flarum/common/components/LinkButton';
import Icon from 'flarum/common/components/Icon';
import BadgeUserList from './BadgeUserList';
export default class BadgeItemPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--index';
    const found = app.store.getById('badges', m.route.param('id'));
    this.loading = !found;
    if (!found) {
      // Load badge
      app.store.find('badges', m.route.param('id')).then(badge => {
        this.loading = false;
        app.history.push('badgeItemPage', badge.name());
        this.setTitle(badge);
        m.redraw();
      });
    } else {
      app.history.push('badgeItemPage', found.name());
      this.setTitle(found);
    }
  }
  setTitle(badge) {
    app.setTitle(`${badge.name()} - ${app.translator.trans('v17development-flarum-badges.forum.badge.badges', {}, true)}`);
  }
  view() {
    const badge = app.store.getById('badges', m.route.param('id'));
    return m(PageStructure, {
      className: "IndexPage BadgeItemPage",
      hero: () => m(WelcomeHero, null),
      sidebar: () => m(IndexSidebar, null)
    }, m(LinkButton, {
      href: app.route('badges'),
      icon: 'fas fa-chevron-left',
      className: 'Button BadgesOverviewButton'
    }, app.translator.trans('v17development-flarum-badges.forum.badge.badges')), this.loading && m(LoadingIndicator, {
      size: 'large'
    }), !this.loading && m("div", {
      className: 'BadgeUserListInfo'
    }, badge.icon() && m(Icon, {
      name: badge.icon()
    }), m("div", {
      className: 'BadgeUserListInfo-meta'
    }, m("h3", null, badge.name()), m("p", null, badge.description()))), badge && m("h3", null, app.translator.trans('v17development-flarum-badges.forum.badge.earned_by_count', {
      count: badge.earnedAmount(),
      b: m("b", null)
    })), !this.loading && app.forum.attribute('canViewDetailedBadgeUsers') && m(BadgeUserList, {
      state: app.userBadgeListState,
      badgeId: badge.id()
    }));
  }
}
flarum.reg.add('v17development-user-badges', 'forum/components/BadgeItemPage', BadgeItemPage);